import { useT } from "@/i18n";
import { inputBarMessages } from "@/i18n/messages/input-bar";

export interface WorkerComposerAlertsProps {
  alert: string | null;
  waitingForReply: boolean;
  canOpenParent: boolean;
  busy: boolean;
  onOpenParent: () => void;
  /** Keeps test ids distinct when several worker composers share a window. */
  testIdPrefix?: string;
}

/** Worker alert, "Waiting for your reply" and the open-parent action. */
export function WorkerComposerAlerts({
  alert,
  waitingForReply,
  canOpenParent,
  busy,
  onOpenParent,
  testIdPrefix = "task-conversation",
}: WorkerComposerAlertsProps) {
  const t = useT(inputBarMessages);
  if (!alert && !waitingForReply && !canOpenParent) return null;
  return (
    <p className="flex flex-wrap items-center gap-x-2 px-3 pb-1 text-appkit-mini">
      {alert && (
        <span role="alert" className="text-danger">
          {alert}
        </span>
      )}
      {waitingForReply && (
        <span role="status" className="text-muted">
          {t("waitingForReply")}
        </span>
      )}
      {canOpenParent && (
        <button
          type="button"
          disabled={busy}
          data-testid={`${testIdPrefix}-open-parent`}
          className="font-medium text-muted transition-colors hover:text-primary"
          onClick={onOpenParent}
        >
          {t("openParentConversation")}
        </button>
      )}
    </p>
  );
}
